const PAYMNET_FAILED = {
	dataAid: 'paymentFailed',
	title: {
		text: 'Payment failed',
	},
	subtitle: {
		text: 'If any amount is debited from your account, it will be credited back within 3-5 working days',
	},
	button: {
		title: 'RETRY',
	},
};

const IPPB_DISCLIAMER = {
	dataAid: 'ippbDisclaimer',
	title: {
		text: 'DISCLAIMER:',
	},
	options: [
		(
			productName = '',
		) => `India Post Payments Bank (hereto also referred as "IPPB") has
        entered into a limited term partnership with M/s Finwizard Technology
        Pvt Ltd. (popularly known & hereafter referred as "${productName}") to
        facilitate Mutual Fund investments.`,
		(
			productName = '',
		) => `IPPB, the bank, through its field distribution teams, including the
        BC channel will only provide referral of the "${productName} Mobile App" to
        its customers.`,
		`Mutual Funds are subject to market risks.`,
		`IPPB nor any of its affiliates, does not in any way, assure any
        quantum of returns from the mutual funds`,
		(
			productName = '',
		) => `IPPB and all its affiliates shall not be responsible for any kind
        of deficiency in the services of ${productName}.`,
		`I have read, understood and agree to the terms and conditions as
        above.`,
	],
	button: {
		text: 'CONTINUE',
	},
};

const BANK = {
	iconDataAid: 'left',
	title: {
		text: 'Pay using',
		dataAid: 'heading',
	},
	bankName: {
		dataAid: 'title',
	},
	primaryTag: {
		dataAid: 'primary',
		text: 'Primary',
	},
	accountNumber: {
		dataAid: 'accountNumber',
	},
	button: {
		text: 'Change',
		dataAid: 'changeBank',
	},
};

const ADD_FUNDS_CTA = {
	dataAid: 'addFunds',
};

const SELECTION_NOTE = {
	note: {
		text: 'Pay only via',
		dataAid: 'note',
	},
	icon: {
		dataAid: 'left',
	},
	bankName: {
		dataAid: 'bankName',
	},
};

const UPI_LIMIT_NOTE = {
	icon: {
		dataAid: 'left',
	},
	title: {
		text: 'UPI',
		dataAid: 'title',
	},
	subtitle: {
		text: 'UPI is not available for transactions above ₹1,00,000',
		dataAid: 'subtitle',
	},
};

const NET_BANKING = {
	title: {
		text: 'NetBanking',
		dataAid: 'title',
	},
	selection: {
		dataAid: 'netbanking',
	},
};

const UPI = {
	iconDataAid: 'bank',
	title: {
		text: 'UPI',
		dataAid: 'upi',
	},
	addNew: {
		text: 'Add a new UPI',
	},
	mode: {
		text: 'Pay only via',
		dataAid: 'paymentMode',
	},
	bank: {
		dataAid: 'bankName',
	},
	secure: {
		text: 'Securely save for future use',
		dataAid: 'checkbox',
	},
	add: {
		text: 'Add a new UPI',
		dataAid: 'addNewUpi',
	},
	gpay: {
		title: 'Google Pay',
		dataAid: 'gpay',
	},
	phonepe: {
		title: 'PhonePe',
		dataAid: 'phonepe',
	},
	paytm: {
		title: 'Paytm',
		dataAid: 'paytm',
	},
	others: {
		title: 'Other UPI apps',
		dataAid: 'others',
	},
	newUpiInputField: {
		text: 'Enter UPI',
		dataAid: 'newUpiInput',
	},
	invalidVpa: {
		text: 'Enter correct UPI ID to proceed',
		dataAid: 'errorMessage',
	},
};

const NEFT_SELECTION = {
	title: {
		text: 'Bank Transfer',
		dataAid: 'title',
	},
	selectionMode: {
		dataAid: 'neftSelection',
		title: {
			text: 'Add via NEFT/RTGS/IMPS',
			dataAid: 'title',
		},
	},
};

const BANK_TRANFER = {
	title: {
		text: 'Bank tranfer',
		dataAid: 'bankTransfer',
	},
	subtitle: {
		text: 'Add via NEFT/RTGS/IMPS',
		dataAid: 'description',
	},
	iconLeftDataAid: 'left',
	iconRightDataAid: 'left',
};

const PAYMENT_FAILED_SHEET = {
	title: {
		text: 'Payment failed',
	},
	subtitle: {
		text: 'If any amount is debited from your account, it will be credited back within 3-5 working days',
	},
	primaryCta: {
		text: 'Retry',
	},
	secondaryCta: {
		text: 'Try other Payment Modes',
	},
};

const MISCELLANEOUS = {
	PaymentModeNotSupported: 'Selected payment mode is not supported',
}

const PAYMENT_LANDING = {
	screenDataAid: 'paymentGateway',
	headerData: {
		title: 'Select payment mode',
		dataAid: 'amount',
	},
	buttonTitle: {
		text: 'PAY',
		dataAid: 'primary',
	},
	netbanking: {
		text: 'NetBanking',
		dataAid: 'netBanking',
	},
	selectBank: {
		title: 'Select bank account',
		dataAid: 'selectBank',
	},
	upi: UPI,
	bank: BANK,
	paymentFailed: PAYMNET_FAILED,
	ippbDisclaimer: IPPB_DISCLIAMER,
	ADD_FUNDS_CTA,
	SELECTION_NOTE,
	UPI_LIMIT_NOTE,
	NET_BANKING,
	NEFT_SELECTION,
	PAYMENT_FAILED_SHEET,
	BANK_TRANFER,
	...MISCELLANEOUS,
};

export default PAYMENT_LANDING;
